import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserDataService } from 'src/app/services/user-data/user-data.service';

@Injectable({
  providedIn: 'root'
})
export class GatewayConfigurationGuard implements CanActivate {

  constructor(
    private router: Router,
    private userData: UserDataService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.verifyGatewayUrlConfiguration();
  }

  async verifyGatewayUrlConfiguration(): Promise<boolean | UrlTree> {
    var isGatewayUrlConfigured = await this.userData.isGatewayConfigured();
    if (isGatewayUrlConfigured) {
      return true;
    }
    else {
      return this.router.parseUrl('/gateway');
    }
  }
}
